import React, { useState } from 'react';
import './Login.css'; // Import the CSS for styling
import { Footer, Header } from '../basicComponent/Basic';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useMutation } from 'react-query';
import {url,localUrl} from '../../BaseUrl'
const Login = () => {
  const [adminEmail, setadminEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLogin, setIsLogin] = useState(false);

  const navigate = useNavigate();

  // Define the login mutation
  const mutation = useMutation(async (loginData) => {
    const response = await axios.post(`${url}/api/auth/login`, loginData);
    return response.data;
  }, {
    onSuccess: (data) => {
      // Handle success (e.g., store the token and navigate to dashboard)
      setSuccessMessage('Login successful!');
      sessionStorage.setItem('token', data.token); 
      setIsLogin(true);
      navigate("/manageedu/admin", { state: true });
      
    },
    onError: (error) => {
      // Handle errors (e.g., display an error message)
      setErrorMessage('Login failed. Please check your credentials.');
      setIsLogin(false);
    }
  });

  const handleLogin = async () => {
    setErrorMessage('');
    setSuccessMessage('');
    
    // Basic validation
    if (!adminEmail || !password) {
      setErrorMessage('Both fields are required!');
      return;
    }

    const loginData = { adminEmail, password };

    // Trigger the mutation
    mutation.mutate(loginData);
  };

  return (
    <div>
      <Header LoggedIn={isLogin} />
      <div className="login-container">
        <h2>Login</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}
        
        <div className="form-group">
          <input
            type="email"
            placeholder="Admin Email"
            value={adminEmail}
            onChange={(e) => setadminEmail(e.target.value)}
            className={`form-input ${adminEmail ? '' : 'input-error'}`}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`form-input ${password ? '' : 'input-error'}`}
          />
        </div>
        <button className="submit-btn" onClick={handleLogin} disabled={mutation.isLoading}>
          {mutation.isLoading ? 'Logging in...' : 'Login'}
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
